import { FaPlus } from "react-icons/fa";

export const TASK_MANAGEMENT_COMPONENTS = {
    "create_task": {
        title: "Create Task",
        icon: FaPlus,
        iconProps: {},
        permissions: [
            {
                permission_code: "APPLICATION_CREATE_TASK"
            }
        ],
    },
    "view_tasks": {
        title: "Task Management Dashboard",
        permissions: [
            {
                // permission_code: "TASKS_VIEW"
                permission_code: "QMS_STAGE_VIEW"
            }
        ],
    },
    "approve_task": {
        permissions: [
            {
                permission_code: "QMS_APPROVE_REJECT"
            }
        ],
    },
    "reject_task": {
        permissions: [
            {
                permission_code: "QMS_APPROVE_REJECT"
            }
        ],
    },
    "allow_comments": {
        permissions: [
            {
                permission_code: "QMS_ALLOW_COMMENTS"
            }
        ],
    },
}